<template>
  <div>
    <draggable
      :id="id + '_draggable'"
      v-model="valueLocal"
      :group="id"
      @start="drag = true"
      @end="drag = false"
      @change="change"
    >
      <div v-for="(element, index) in valueLocal" :key="index + 'dragg'" class="item_PDragAndDrop">
        <span class="material-icons icon_PDragAndDrop">drag_indicator</span>

        <span>{{ element.label }}</span>
      </div>
    </draggable>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import draggable from "vuedraggable";

@Component({ components: { draggable } })
export class PDragAndDrop extends Vue {
  @Prop({ required: true }) value!: any[];
  @Prop({ required: true }) id!: string;
  @Watch("value", { deep: true, immediate: true })
  onChangeValue(): void {
    this.valueLocal = [];
    this.value.forEach((fi: any) => {
      this.valueLocal.push({ ...fi });
    });
  }
  drag = false;
  valueLocal: any[] = [];
  change(): void {
    this.$emit("input", this.valueLocal);
    this.$emit("change", this.valueLocal);
  }
}
export default PDragAndDrop;
</script>
<style scoped>
.item_PDragAndDrop {
  display: flex;
  border-radius: 4px;
  border: solid 1px #e4e4e4;
  background-color: #fff;
  padding: 3px 5px;
  align-items: center;
  margin-bottom: 2px;
  cursor: -webkit-grab;
  cursor: grab;
  font-size: 0.7rem;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: normal;
  color: #4c4c4c;
}
.item_PDragAndDrop:-moz-drag-over {
  cursor: -webkit-grabbing;
  cursor: grabbing;
}
.icon_PDragAndDrop {
  font-size: 1rem;
  color: #d8d8d8;
}
</style>
